import { useDesign } from "./store";

/**
 * "Show the furniture picker" requests from outside the Design view (the
 * feng shui guide's "Add furniture" step). The Design view owns the picker
 * (a sheet on phones, the side panel on desktop), so a request switches to
 * Design, clears the selection (the side panel only lists furniture while
 * nothing is selected) and is delivered once the Design view subscribes.
 */

let pending = false;
const listeners = new Set<() => void>();

function flush() {
  if (!pending || listeners.size === 0) return;
  pending = false;
  for (const l of listeners) l();
}

export function requestFurniturePicker(): void {
  const s = useDesign.getState();
  if (s.view !== "design") s.setView("design");
  if (s.selectedFurnitureId != null) s.selectFurniture(null);
  pending = true;
  flush();
}

export function subscribeFurniturePickerRequests(listener: () => void): () => void {
  listeners.add(listener);
  if (pending) queueMicrotask(flush);
  return () => {
    listeners.delete(listener);
  };
}

/** Test-only: drop an undelivered request. */
export function _resetFurniturePickerRequestsForTests(): void {
  pending = false;
}
